import React, { useEffect, useState, useMemo, useRef } from 'react';

import { GenericField, Type } from 'src/components/base/fields/GenericField';

import * as QA from 'shared/utils/queryAnalysis';


const Ftn = QA.FieldTypeName;
const typesInfo = [
  {
    types: [Ftn.Currency],
    // props: { suffix: `USD/EUR/BYN` },
    type: Type.Double,
  },
  {
    types: [Ftn.Percent],
    props: { suffix: '%' },
    type: Type.Double,
  },
  {
    types: [Ftn.Double],
    type: Type.Double,
  },
  {
    types: [Ftn.Int, Ftn.Byte],
    type: Type.Int,
  },
  {
    types: [Ftn.Textarea, Ftn.Address],
    type: Type.String,
    props: { multiline: true, rows: 3 },
  },
  {
    types: [Ftn.Email, Ftn.Phone, Ftn.String, Ftn.Url],
    type: Type.String,  
  },
];


export const SupportedTypes = typesInfo.flatMap(x => x.types);


export function SimpleField({ rawField, ...restProps }) {
  const { props = {}, type = Type.String } = useMemo(() => 
    typesInfo.find(x => x.types.includes(rawField.type))
  , [rawField]);

  return (
    <GenericField {...restProps} textFieldProps={props} type={type} />
  );
}


export function getDefaultValue(rawField) {
  const { type } = rawField;
  return QA.NumberFields.includes(type) ? 0 : '';
}

export default SimpleField;